import './AnnouncementBar.css';

export default function AnnouncementBar() {
  return (
    <div className="announcement-bar">
      A LITTLE JOY, FROM THE TWO OF US.
    </div>
  );
}
